/** https://stackoverflow.com/questions/3466850/regular-expression-to-enforce-complex-passwords-matching-3-out-of-4-rules */

export const passwordRegExp = {
  letterSmall: /[a-z]/,
  letterCap: /[A-Z]/,
  number: /[\d]/,
  sym: /[\W]/,
  title: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[\d])(?=.*[\W]).{8,}/,
};
